import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { Button } from "@material-ui/core";

const Unauthorized = () => {
  const handleOk = () => {
    window.location.href = "https://www.acc.com";
  };
  return (
    <Container style={{ marginTop: 100, marginBottom: 100 }}>
      <Typography variant="h5" align={"center"}>
        Sorry, you do not currently have permission to access the Chapter
        Financial Portal. Please contact{" "}
        <a href="mailto:chapters@acc.com">chapters@acc.com</a> if you believe
        this is a mistake.
      </Typography>
      <Typography align={"center"} style={{ marginTop: 20 }}>
        <Button
          variant="contained"
          onClick={handleOk}
          style={{ backgroundColor: "#c6093b", color: "#fff" }}
        >
          OK
        </Button>
      </Typography>
    </Container>
  );
};

export default Unauthorized;
